<template>
  <div class="million-read-report-week-data">
    <div class="million-read-report-week-data-total-learn-minute">
      <div class="title">
        <span>本周学习时长</span>
      </div>
      <div class="number"><span>{{ thisWeek.totalLearnMinute }}</span>分钟</div>
      <div class="info">
        <div class="last-week">上周 {{ lastWeek.totalLearnMinute }}</div>
        <div class="exceed-percent">超过了{{ exceedPercent }}的用户</div>
      </div>
    </div>
    <div class="million-read-report-week-data-detail-info">
      <div class="million-read-report-week-data-detail-info-continuous-learn">
        <div class="title">·连续学习·</div>
        <div class="this-week-number">
          <span>{{ thisWeek.continuousLearn }}</span>天
        </div>
        <div class="last-week-number">
          上周 {{ lastWeek.continuousLearn }}
        </div>
      </div>
      <div class="million-read-report-week-data-detail-info-cumulative-play">
        <div class="title">·累积播放·</div>
        <div class="this-week-number">
          <span>{{ thisWeek.cumulativePlay }}</span>条
        </div>
        <div class="last-week-number">
          上周 {{ lastWeek.cumulativePlay }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import validator from '@/utils/validator';

  export default {
    name: 'MillionReadReportWeekData',
    components: {},
    props: {
      thisWeek: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
      lastWeek: {
        validator(val) {
          return validator.isObject(val);
        },
        required: true,
      },
      exceedPercent: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-report-week-data {
    box-sizing: border-box;
    width: 750px;
    height: 838px;
    margin: 0 auto;
    padding-top: 100px;
    background: url('~@/assets/img/million_read/report_learn_bg.png') no-repeat;
    background-size: contain;

    &-total-learn-minute {
      .title {
        box-sizing: border-box;
        position: relative;
        margin-bottom: @size-medium;
        padding-left: 72px;
        color: @color-text-base;
        font-size: @font-size-extra-large;
        font-weight: @font-weight-strong;
        line-height: 1;
        &:after {
          position: absolute;
          z-index: 1;
          bottom: -6px;
          left: 66px;
          width: 256px;
          height: 20px;
          content: '';
          background: #ffe8be;
          border-radius: 5px;
        }
        span {
          position: relative;
          z-index: 2;
        }
      }
      .number {
        box-sizing: border-box;
        margin-bottom: 24px;
        padding-left: 72px;
        color: @color-text-light;
        font-size: 26px;
        line-height: 1.4;
        span {
          display: inline;
          margin-right: 8px;
          color: @color-text-base;
          font-size: 64px;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
      }
      .info {
        box-sizing: border-box;
        margin-bottom: 110px;
        padding: 0 74px 0 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .last-week {
          box-sizing: border-box;
          padding: 15px 24px 15px 16px;
          color: #a1a1b3;
          font-size: 26px;
          line-height: 1;
          background: #f5f6fa;
          border-radius: 0 16px 16px 0;
        }
        .exceed-percent {
          color: #fea500;
          font-size: @font-size-base;
          line-height: 1;
        }
      }
    }
    &-detail-info {
      box-sizing: border-box;
      padding: 0 72px;
      display: flex;
      justify-content: space-between;
      &-continuous-learn,
      &-cumulative-play {
        box-sizing: border-box;
        position: relative;
        width: 288px;
        height: 280px;
        padding-top: @size-medium;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f5f6fa;
        border-radius: 8px 8px 20px 20px;
        &:before {
          position: absolute;
          top: 0;
          left: 104px;
          width: 80px;
          height: 8px;
          content: '';
          background: #fed100;
          border-radius: 2px;
        }
        .title {
          margin-bottom: @size-base;
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        .this-week-number {
          margin-bottom: 24px;
          color: @color-text-light;
          font-size: 26px;
          span {
            display: inline;
            margin-right: 8px;
            color: @color-text-base;
            font-size: 64px;
            font-weight: @font-weight-strong;
            line-height: 1;
          }
        }
        .last-week-number {
          color: #a1a1b3;
          font-size: 26px;
          line-height: 1;
        }
      }
    }
  }

</style>
